import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buttonClass, type ButtonSize, type ButtonVariant } from '../../utils/buttonStyles';
interface ButtonLinkProps {
  to: string;
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  showArrow?: boolean;
  className?: string;
  ariaLabel?: string;
  onClick?: () => void;
}
export function ButtonLink({
  to,
  children,
  variant = 'primary',
  size = 'md',
  showArrow = false,
  className = '',
  ariaLabel,
  onClick
}: ButtonLinkProps) {
  const classes = buttonClass(variant, size, className);
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-547" data-mp="1npoo6f91urwf" />}
    </>;
  if (/^(https?:|mailto:|tel:)/.test(to)) {
    return <a href={to} className={classes} aria-label={ariaLabel} onClick={onClick} data-id="element-548" data-mp="3d5xsrzghfgp5">
        {content}
      </a>;
  }
  return <Link to={to} className={classes} aria-label={ariaLabel} onClick={onClick} data-id="element-549" data-mp="3i1wq4cjsg91p">
      {content}
    </Link>;
}